// SEQ-240 audit B, row 35. The project Status (P&L) tab built its monthly
// expenses only from the organisation's category list, so a typed value whose
// category had since left the list was dropped from the tab's totals. The
// analytics page counts the same value as unmapped, and the main dashboard
// counts it as Other (plan decision D4, noted in pnlCalculationCore.ts). This
// names those categories so the tab hands them to the engine, which already
// treats an unknown category as a deductible Other cost.

/** The category names that hold a typed value but are not in the organisation list, in first-seen order. */
export function orphanCategoryNames(
  categories: ReadonlyArray<{ name: string }>,
  valueRows: Iterable<{ category: string }>,
): string[] {
  const known = new Set(categories.map((c) => c.name));
  const orphans: string[] = [];
  const seen = new Set<string>();
  for (const row of valueRows) {
    const name = row.category;
    if (typeof name !== "string" || name === "" || known.has(name) || seen.has(name)) continue;
    seen.add(name);
    orphans.push(name);
  }
  return orphans;
}
